import React from 'react';

import { FormattedMessage } from 'react-intl';

import IconFemtasy from 'components/IconFemtasy';
import Typography from 'components/Typography';

import { useTracking } from 'hooks/useTracking';

import './style.scss';

export const SearchInput = () => {
  const { trackContentInteraction } = useTracking();

  const handleClick = React.useCallback(() => {
    trackContentInteraction(
      'click',
      'click-search-button',
      'click-search-button',
    );
  }, [trackContentInteraction]);

  return (
    <button className="SearchInput__open-button" onClick={handleClick}>
      <IconFemtasy icon="Searchline" />
      <Typography variant="h3">
        <FormattedMessage id="components.SearchInput.open_button" />
      </Typography>
    </button>
  );
};

export default SearchInput;
